(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accordion"] && !Shopify.designMode) return;
  try {
    /* 点击空白处自动收起所有展开的手风琴 */
document.addEventListener('click', function (e) {
  const accordions = document.querySelectorAll('.accordion details[open]');
  let clickInsideAccordion = false;

  accordions.forEach(acc => {
    if (acc.contains(e.target)) {
      clickInsideAccordion = true;
    }
  });

  if (!clickInsideAccordion) {
    accordions.forEach(acc => acc.removeAttribute('open'));
  }
});

/* 打开一个时自动关闭其他已展开项 */
document.querySelectorAll('.accordion details').forEach(detail => {
  detail.addEventListener('toggle', () => {
    if (detail.open) {
      document.querySelectorAll('.accordion details').forEach(other => {
        if (other !== detail) other.removeAttribute('open');
      });
    }
  });
});
  } catch(e) { console.error(e); }
})();

})();
